import { DatePicker, Dropdown, Menu, Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./proposal_form.css";
import AppTextField from "../../../component/app_text_field/app_text_field";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import UtilBloc from "../../../../bloc/util_bloc";
import AppModal from "../../../component/app_modal/app_modal";
import AppSelectButton from "../../../component/app_select_button/app_select_button";
import App_table from "../../../component/app_table/app_table";
import { ReactComponent as ThreeDotsIcon } from "../../../../ThreeDots.svg";
import { ReactComponent as EditIcon } from "../../../../Edit.svg";
import { ReactComponent as BookmarkIcon } from "../../../../Bookmark.svg";
import FormBloc from "../../../../bloc/forms_bloc";
import moment from "moment";

class ExtendedHealthDeclaration extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            extendHealthDeclarationData: {
                height: null,
                weight: null,
                isSmoker: null,
                hasGeneticDisorder: null,
                isConsultOrTreatment: null,
                isPregnant: null,
                // pregnancyMonth: null,
                hasHeartDisease: false,
                hasHighBloodPressure: false,
                hasMentalIllness: false,
                hasCancer: false,
                hasHIV: false,
                hasDiabetes: false,
                hasObstructivePulmonaryDisease: false,
                hasLiverDisease: false,
                hasKidneyDisease: false,
                lossSenses: false,
                physicalDisability: false,
                prolongedFatigue: false,
                unexplainedWeightLoss: false,
                abnormalLump: false,
                bloodUrine: false,
                newPain: false,
            },
            medicalCondition: null,
            diagnosisDate: null,
            treatmentPrescribed: null,
            doctorName: null,
            doctorAddress: null,
            country: null,
            state: null,
            postcode: null,
            city: null,
            consultOrTreatmentEdit: false,
            heartDiseaseDataEdit: false,
            highBloodPressureDataEdit: false,
            mentalIllnessDataEdit: false,
            cancerDataEdit: false,
            hivDataEdit: false,
            diabetesDataEdit: false,
            pulmonaryDataEdit: false,
            liverDiseaseDataEdit: false,
            kidneyDiseaseDataEdit: false,
            lossSensesDataEdit: false,
            physicalDisabilityDataEdit: false,
            fatigueDataEdit: false,
            weightLossDataEdit: false,
            abnormalDataEdit: false,
            bloodUrineDataEdit: false,
            persistentDataEdit: false,
            geneticDisorderDataEdit: false,
            countryList: [],
            stateList: [],
            cityList: [],
            postcodeList: [],
            heartDiseaseData: {
                questionNo: "q4a",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.hasHeartDisease,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            highBloodPressureData: {
                questionNo: "q4b",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.highBloodPressure,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            mentalIllnessData: {
                questionNo: "q4c",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.mentalIllness,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            cancerData: {
                questionNo: "q4d",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isCancer,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            hivData: {
                questionNo: "q4e",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isHIV,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            diabetesData: {
                questionNo: "q4f",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isDiabetes,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            pulmonaryData: {
                questionNo: "q4g",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isPulmonaryDisease,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            liverDiseaseData: {
                questionNo: "q4h",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isLiverDisease,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            kidneyDiseaseData: {
                questionNo: "q4i",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isKidneyDisease,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            lossSensesData: {
                questionNo: "q4j",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.lossSenses,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            physicalDisabilityData: {
                questionNo: "q4k",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.physicalDisability,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            consultationData: {
                questionNo: "q5",
                condition: '',
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            fatigueData: {
                questionNo: "q6a",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.prolongedFatigue,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            weightLossData: {
                questionNo: "q6b",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.unexplainedLossWeight,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            abnormalData: {
                questionNo: "q6c",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.abnormalLump,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            bloodUrineData: {
                questionNo: "q6d",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.bloodInUrine,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            persistentData: {
                questionNo: "q6e",
                condition: Config.proposal.formDataMapping.step1.extendedHealthFormTitle.newPersistentPain,
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            geneticDisorderData: {
                questionNo: "q7",
                condition: '',
                dateOfDiagnosis: '',
                treatment: '',
                doctorName: '',
                doctorAddress: '',
            },
            pregnancyDetails: {
                questionNo: "q8",
                pregnancyMonth: ''
            },
            selectedRowIdx: null,
            errorMessage: 'Fill in the required field.',
            addDiagnosedDiseaseDetailModalOpen: false,
            addConsultTreatmentModalOpen: false,
            editDiagnosedDiseaseDetailModalOpen: false,
            addInvestigationDetailModalOpen: false,
            editInvestigationDetailModalOpen: false,
            addGeneticDisorderDetailModalOpen: false,
            editGeneticDisorderDetailModalOpen: false,
            isUpdate: false,
        };
    }

    columns(formDataArr, section) {
        return [
            {
                title: 'No.',
                // dataIndex: 'num',
                key: 'num',
                render: (text, record) => (formDataArr.indexOf(record) + 1)
            },
            {
                title: 'Medical Condition',
                dataIndex: 'medicalCondition',
                key: 'medicalCondition',
            },
            {
                title: 'Date of Diagnosis',
                dataIndex: 'diagnosisDate',
                render: (diagnosisDate) => (moment(diagnosisDate?._d).format("DD/MM/YYYY"))
            },
            {
                title: 'Treatment Prescribed',
                dataIndex: 'treatmentPrescribed',
                key: 'treatmentPrescribed',
            },
            {
                title: 'Attending Doctor’s Name',
                dataIndex: 'doctorName',
                key: 'doctorName',
            },
            {
                title: 'Attending Doctor’s Address ',
                dataIndex: 'doctorAddress',
                key: 'doctorAddress',
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Dropdown
                        overlay={
                            <Menu
                                style={{
                                    marginTop: "12px",
                                    width: '200px'
                                }}
                                items={this.getDropDownItem(_, formDataArr.indexOf(record), section)}
                            />
                        }
                        trigger={["click"]}
                        className="action_trigger"
                    >
                        <ThreeDotsIcon />
                    </Dropdown>

                ),
            },
        ];
    }

    getDropDownItem = (data, idx, sectionName) => {

        let item = [
            {
                label: (
                    <div
                        onClick={() => {
                            this.handleSetFormData(data, idx);
                            sectionName == 'diagnosed' ? this.handleAddDiagnosedDiseaseDetailModalOpen() :
                                sectionName == 'investigation' ? this.handleAddInvestigateOrOperationDetailModalOpen() :
                                    sectionName == 'consult' ? this.handleAddConsultTreatmentDetailslModalOpen() :
                                        this.handleAddGeneticDisorderDetailModalOpen()
                        }}
                        className="dropdown_item"
                    >
                        Update
                    </div>
                ),
                key: 'update'
            },
            {
                label: (
                    <div
                        onClick={() => {
                            sectionName == 'diagnosed' ? this.handleDeleteDiagnosedDiseaseData(idx) :
                                sectionName == 'investigation' ? this.handleDeleteInvestigationOrTreatmentData(idx) :
                                    sectionName == 'consult' ? this.handleDeleteConsultTreatmentData(idx) :
                                        this.handleDeleteGeneticDisorderData(idx)
                        }}
                        className="dropdown_item"
                    >
                        Delete
                    </div>

                ),
                key: 'delete'
            },
        ]

        return item;
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.extendHealthDeclarationData;
        let {
            heartDiseaseData, highBloodPressureData,
            mentalIllnessData, cancerData, hivData, diabetesData, pulmonaryData, liverDiseaseData,
            kidneyDiseaseData, lossSensesData, physicalDisabilityData, consultationData, fatigueData,
            weightLossData, abnormalData, bloodUrineData, persistentData, geneticDisorderData, pregnancyDetails
        } = this.state;

        formData && Object.keys(formData).map(function (key) {
            if (key == 'details') {
                formData[key] && formData[key].map((item) => {
                    if (item.questionNo == 'q4a') {
                        heartDiseaseData = item
                    }
                    if (item.questionNo == 'q4b') {
                        highBloodPressureData = item
                    }
                    if (item.questionNo == 'q4c') {
                        mentalIllnessData = item
                    }
                    if (item.questionNo == 'q4d') {
                        cancerData = item
                    }
                    if (item.questionNo == 'q4e') {
                        hivData = item
                    }
                    if (item.questionNo == 'q4f') {
                        diabetesData = item
                    }
                    if (item.questionNo == 'q4g') {
                        pulmonaryData = item
                    }
                    if (item.questionNo == 'q4h') {
                        liverDiseaseData = item
                    }
                    if (item.questionNo == 'q4i') {
                        kidneyDiseaseData = item
                    }
                    if (item.questionNo == 'q4j') {
                        lossSensesData = item
                    }
                    if (item.questionNo == 'q4k') {
                        physicalDisabilityData = item
                    }
                    if (item.questionNo == 'q5') {
                        consultationData = item
                    }
                    if (item.questionNo == 'q6a') {
                        fatigueData = item
                    }
                    if (item.questionNo == 'q6b') {
                        weightLossData = item
                    }
                    if (item.questionNo == 'q6c') {
                        abnormalData = item
                    }
                    if (item.questionNo == 'q6d') {
                        bloodUrineData = item
                    }
                    if (item.questionNo == 'q6e') {
                        persistentData = item
                    }
                    if (item.questionNo == 'q7') {
                        geneticDisorderData = item
                    }
                    if (item.questionNo == 'q8') {
                        pregnancyDetails = item
                    }
                })
            } else {
                stateData[key] = formData[key];
            }
        })
        this.setState({
            extendHealthDeclarationData: stateData,
            heartDiseaseData: heartDiseaseData,
            highBloodPressureData: highBloodPressureData,
            mentalIllnessData: mentalIllnessData,
            cancerData: cancerData,
            hivData: hivData,
            diabetesData: diabetesData,
            pulmonaryData: pulmonaryData,
            liverDiseaseData: liverDiseaseData,
            kidneyDiseaseData: kidneyDiseaseData,
            lossSensesData: lossSensesData,
            physicalDisabilityData: physicalDisabilityData,
            consultationData: consultationData,
            fatigueData: fatigueData,
            weightLossData: weightLossData,
            abnormalData: abnormalData,
            bloodUrineData: bloodUrineData,
            persistentData: persistentData,
            geneticDisorderData: geneticDisorderData,
            pregnancyDetails: pregnancyDetails,
        }, () => {
            UtilBloc.extendedHealthDetailsDataValidation(this.state) && this.setPropValidation(true);
        })
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getFormFields() {
        return this.props.fields;
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    handleMedicalConditionChange = (val) => {
        this.setState({ medicalCondition: val });
    }

    handleDiagnosisDateChange = (date) => {
        this.setState({ diagnosisDate: date });
    }

    handleTreatmentPrescribedChange = (val) => {
        this.setState({ treatmentPrescribed: val });
    }

    handleDoctorNameChange = (val) => {
        this.setState({ doctorName: val });
    }

    handleDoctorAddressChange = (val) => {
        this.setState({ doctorAddress: val });
    }

    handleCountryChange = (val) => {
        this.setState({ country: val });
    }

    handleStateChange = (val) => {
        this.setState({ state: val });
    }

    handleCityChange = (val) => {
        this.setState({ city: val });
    }

    handlePostcodeChange = (val) => {
        this.setState({ postcode: val });
    }

    onValidateForm = () => {
        let validated = UtilBloc.extendedHealthDetailsDataValidation(this.state);
        this.setPropValidation(validated);
        this.setPropValue();
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    setPropValue = () => {
        let valueobj = this.state.extendHealthDeclarationData;
        let detailData = { details: [] };
        if (valueobj['isConsultOrTreatment'] == 'Yes') {
            detailData.details.push(this.state.consultationData);
        }
        if (valueobj['hasGeneticDisorder'] == 'Yes') {
            detailData.details.push(this.state.geneticDisorderData);
        }
        if (valueobj['hasHeartDisease'] == 'Yes') {
            detailData.details.push(this.state.heartDiseaseData);
        }
        if (valueobj['hasHighBloodPressure'] == 'Yes') {
            detailData.details.push(this.state.highBloodPressureData);
        }
        if (valueobj['hasMentalIllness'] == 'Yes') {
            detailData.details.push(this.state.mentalIllnessData);
        }
        if (valueobj['hasCancer'] == 'Yes') {
            detailData.details.push(this.state.cancerData);
        }
        if (valueobj['hasHIV'] == 'Yes') {
            detailData.details.push(this.state.hivData);
        }
        if (valueobj['hasDiabetes'] == 'Yes') {
            detailData.details.push(this.state.diabetesData);
        }
        if (valueobj['hasObstructivePulmonaryDisease'] == 'Yes') {
            detailData.details.push(this.state.pulmonaryData);
        }
        if (valueobj['hasLiverDisease'] == 'Yes') {
            detailData.details.push(this.state.liverDiseaseData);
        }
        if (valueobj['hasKidneyDisease'] == 'Yes') {
            detailData.details.push(this.state.kidneyDiseaseData);
        }
        if (valueobj['lossSenses'] == 'Yes') {
            detailData.details.push(this.state.lossSensesData);
        }
        if (valueobj['physicalDisability'] == 'Yes') {
            detailData.details.push(this.state.physicalDisabilityData);
        }
        if (valueobj['prolongedFatigue'] == 'Yes') {
            detailData.details.push(this.state.fatigueData);
        }
        if (valueobj['unexplainedWeightLoss'] == 'Yes') {
            detailData.details.push(this.state.weightLossData);
        }
        if (valueobj['abnormalLump'] == 'Yes') {
            detailData.details.push(this.state.abnormalData);
        }
        if (valueobj['bloodUrine'] == 'Yes') {
            detailData.details.push(this.state.bloodUrineData);
        }
        if (valueobj['newPain'] == 'Yes') {
            detailData.details.push(this.state.persistentData);
        }
        if (valueobj['isPregnant'] == 'Yes') {
            detailData.details.push(this.state.pregnancyDetails);
        }
        let value = Object.assign(valueobj, detailData);
        this.props.onChange(value);
    }

    handleValueChange = (field, val) => {
        let data = this.state.extendHealthDeclarationData;
        data[field] = val;

        if (field == 'isConsultOrTreatment' && data[field] == 'No') {
            this.handleClearObj('consultationData', false);
        }
        if (field == 'hasGeneticDisorder' && data[field] == 'No') {
            this.handleClearObj('geneticDisorderData', false);
        }
        if (field == 'hasHeartDisease' && data[field] == 'No') {
            this.handleClearObj('heartDiseaseData', true);
        }
        if (field == 'hasHighBloodPressure' && data[field] == 'No') {
            this.handleClearObj('highBloodPressureData', true);
        }
        if (field == 'hasMentalIllness' && data[field] == 'No') {
            this.handleClearObj('mentalIllnessData', true);
        }
        if (field == 'hasCancer' && data[field] == 'No') {
            this.handleClearObj('cancerData', true);
        }
        if (field == 'hasHIV' && data[field] == 'No') {
            this.handleClearObj('hivData', true);
        }
        if (field == 'hasDiabetes' && data[field] == 'No') {
            this.handleClearObj('diabetesData', true);
        }
        if (field == 'hasObstructivePulmonaryDisease' && data[field] == 'No') {
            this.handleClearObj('pulmonaryData', true);
        }
        if (field == 'hasLiverDisease' && data[field] == 'No') {
            this.handleClearObj('liverDiseaseData', true);
        }
        if (field == 'hasKidneyDisease' && data[field] == 'No') {
            this.handleClearObj('kidneyDiseaseData', true);
        }
        if (field == 'lossSenses' && data[field] == 'No') {
            this.handleClearObj('lossSensesData', true);
        }
        if (field == 'physicalDisability' && data[field] == 'No') {
            this.handleClearObj('physicalDisabilityData', true);
        }
        if (field == 'prolongedFatigue' && data[field] == 'No') {
            this.handleClearObj('fatigueData', true);
        }
        if (field == 'unexplainedWeightLoss' && data[field] == 'No') {
            this.handleClearObj('weightLossData', true);
        }
        if (field == 'abnormalLump' && data[field] == 'No') {
            this.handleClearObj('abnormalData', true);
        }
        if (field == 'bloodUrine' && data[field] == 'No') {
            this.handleClearObj('bloodUrineData', true);
        }
        if (field == 'newPain' && data[field] == 'No') {
            this.handleClearObj('persistentData', true);
        }
        if (field == 'isPregnant' && data[field] == 'No') {
            this.handleClearObj('pregnancyDetails', true);
        }
        this.setState({ extendHealthDeclarationData: data }, () => {
            // This callback function will run after setState is done
            this.onValidateForm();
        });
    }

    handleClearObj(dataObj, constantCondition = false) {
        let obj = this.state[dataObj];
        Object.keys(obj).map(function (key) {
            if ((key == 'condition' && constantCondition) || key == 'questionNo') {
            } else {
                obj[key] = '';
            }
        })
        this.setState({ [dataObj]: obj });
    }

    async handleFormSubmit() {

    }

    handleDetailsDataValueChange(data, key, val) {
        let obj = this.state[data];
        if (key == 'dateOfDiagnosis') {
            obj[key] = (val && val?._d) ? moment(val._d).format('YYYYMMDD') : null;
        } else {
            obj[key] = val;
        }
        this.setState({ [data]: obj }, () => this.onValidateForm());

    }

    renderTableHeader() {
        return (
            <div className="mt-3">
                <div className="row d-flex m-0 table-header-container align-items-center justify-content-center">
                    <div className="" style={{ width: '4%' }}>Yes</div>
                    <div className="" style={{ width: '4%' }}>No</div>
                    <div className="" style={{ width: '23%' }}>Medical Condition</div>
                    <div className="" style={{ width: '12%' }}>Date of Diagnosis</div>
                    <div className="" style={{ width: '20%' }}>Treatment Prescribed</div>
                    <div className="" style={{ width: '14%' }}>Attending Doctor{'\''}s Name</div>
                    <div className="" style={{ width: '18%' }}>Attending Doctor{'\''}s Address </div>
                    <div className="" style={{ width: '5%' }}>Edit</div>
                </div>
            </div>
        )
    }

    renderTableBody(data, dataDetails, conditionAbleEdit, disabled, isEdit, editVarName) {
        return (
            <div className="row d-flex m-0 align-items-center justify-content-center table-body-container">
                <div className="" style={{ width: '4%' }}>
                    <Checkbox
                        onChange={(e) => this.handleValueChange(data, 'Yes')}
                        checked={this.state.extendHealthDeclarationData[data] == 'Yes'}
                    />
                </div>
                <div className="" style={{ width: '4%' }}>
                    <Checkbox
                        onChange={(e) => this.handleValueChange(data, 'No')}
                        checked={this.state.extendHealthDeclarationData[data] == 'No'}
                    />
                </div>
                <div className="" style={{ width: '23%' }}>
                    {conditionAbleEdit ?
                        isEdit && this.state.extendHealthDeclarationData[data] == 'Yes' ?
                            <AppTextField
                                type={'text'}
                                value={this.state[dataDetails]?.condition}
                                onChange={(e) => this.handleDetailsDataValueChange(dataDetails, 'condition', e)}
                            // error={this.state.placeOfBirthErrMsg || false}
                            // errorMessage={this.state.placeOfBirthErrMsg}
                            /> :
                            this.state[dataDetails]?.condition : this.state[dataDetails]?.condition

                    }
                </div>
                <div className="" style={{ width: '12%' }}>
                    {
                        isEdit && this.state.extendHealthDeclarationData[data] == 'Yes' ?
                            <DatePicker
                                onChange={(d) => this.handleDetailsDataValueChange(dataDetails, 'dateOfDiagnosis', d)}
                                style={{ height: '48px', width: '100%' }}
                                placeholder="DD/MM/YYYY"
                                format={'DD/MM/YYYY'}
                                value={this.state[dataDetails]?.dateOfDiagnosis ?
                                    moment(this.state[dataDetails]?.dateOfDiagnosis?._d ? this.state[dataDetails]?.dateOfDiagnosis?._d : this.state[dataDetails]?.dateOfDiagnosis, 'YYYY/MM/DD') :
                                    null}
                            /> :

                            // moment(this.state[dataDetails]?.dateOfDiagnosis, 'DD/MM/YYYY') || moment(this.state[dataDetails]?.dateOfDiagnosis?._d).format('DD/MM/YYYY')
                            this.state[dataDetails]?.dateOfDiagnosis &&
                            moment(this.state[dataDetails]?.dateOfDiagnosis?._d ? this.state[dataDetails]?.dateOfDiagnosis?._d : this.state[dataDetails]?.dateOfDiagnosis).format('DD/MM/YYYY')
                    }
                </div>
                <div className="pt-1" style={{ width: '20%', wordWrap: 'break-word' }}>
                    {
                        isEdit && this.state.extendHealthDeclarationData[data] == 'Yes' ?
                            <AppTextField
                                type={'text'}
                                value={this.state[dataDetails]?.treatment}
                                onChange={(e) => this.handleDetailsDataValueChange(dataDetails, 'treatment', e)}
                            // error={this.state.placeOfBirthErrMsg || false}
                            // errorMessage={this.state.placeOfBirthErrMsg}
                            /> :
                            this.state[dataDetails]?.treatment
                    }
                </div>
                <div className="pt-1" style={{ width: '14%', wordWrap: 'break-word' }}>
                    {
                        isEdit && this.state.extendHealthDeclarationData[data] == 'Yes' ?
                            <AppTextField
                                type={'text'}
                                value={this.state[dataDetails]?.doctorName}
                                onChange={(e) => this.handleDetailsDataValueChange(dataDetails, 'doctorName', e)}
                            // error={this.state.placeOfBirthErrMsg || false}
                            // errorMessage={this.state.placeOfBirthErrMsg}
                            /> :
                            this.state[dataDetails]?.doctorName
                    }
                </div>
                <div className="pt-1" style={{ width: '18%', wordWrap: 'break-word' }}>
                    {
                        isEdit && this.state.extendHealthDeclarationData[data] == 'Yes' ?
                            <AppTextField
                                type={'text'}
                                value={this.state[dataDetails]?.doctorAddress}
                                onChange={(e) => this.handleDetailsDataValueChange(dataDetails, 'doctorAddress', e)}
                            // error={this.state.placeOfBirthErrMsg || false}
                            // errorMessage={this.state.placeOfBirthErrMsg}
                            /> :
                            this.state[dataDetails]?.doctorAddress
                    }
                </div>
                <div className="" style={{ width: '5%' }}>
                    {
                        isEdit && this.state.extendHealthDeclarationData[data] == 'Yes' ?
                            <BookmarkIcon
                                fill={"#183028"}
                                onClick={() => this.setState({ [editVarName]: false })}
                            /> : //isEdit == true
                            <EditIcon
                                fill={disabled ? "#BAC1BE" : "#183028"}
                                onClick={() => disabled ? '' : this.setState({ [editVarName]: true })}
                            />  //== yes/no

                    }
                </div>
            </div>
        )
    }

    height() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.height}
                type={'text'}
                placeholder={'0.00'}
                suffix={'CM'}
                value={this.state.extendHealthDeclarationData.height}
                onChange={(e) => {
                    if (e) {
                        let value = e;
                        if (/^\d*\.?\d*$/.test(value)) {
                            this.handleValueChange(this.getFormFields().height, value);
                        }
                    } else {
                        this.handleValueChange(this.getFormFields().height, e);
                    }
                }}
            />
        )
    }

    weight() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.weight}
                type={'text'}
                placeholder={'0.00'}
                suffix={'KG'}
                value={this.state.extendHealthDeclarationData.weight}
                onChange={(e) => {
                    if (e) {
                        let value = e;
                        if (/^\d*\.?\d*$/.test(value)) {
                            this.handleValueChange(this.getFormFields().weight, value);
                        }
                    } else {
                        this.handleValueChange(this.getFormFields().weight, e);
                    }
                }
                }
            />
        )
    }

    isSmoker() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isSmoker}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            // title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isSmoker}
                            value={this.state.extendHealthDeclarationData.isSmoker}
                            handleNegativePress={() => this.handleValueChange(this.getFormFields().isSmoker, 'No')}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().isSmoker, 'Yes')}
                        />
                    </div>
                </div>
            </div>

        )
    }

    isDiagnosedDisease() {
        return (
            <div className="mr-3" style={{ fontSize: 14, }}>
                {Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isDiagnosed}
                {/* <AppSelectButton
                            // title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isDiagnosed}
                            value={this.state.extendHealthDeclarationData.isDiagnosedDisease}
                            handleNegativePress={() => this.handleValueChange(this.getFormFields().isDiagnosedDisease, 'No')}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().isDiagnosedDisease, 'Yes')}
                        /> */}
                {/* Start render table */}
                {this.renderTableHeader()}
                {this.renderTableBody(
                    'hasHeartDisease',
                    'heartDiseaseData',
                    false,
                    this.state.extendHealthDeclarationData.hasHeartDisease == 'Yes' ? false : true,
                    this.state.heartDiseaseDataEdit,
                    'heartDiseaseDataEdit'
                )}
                {this.renderTableBody(
                    'hasHighBloodPressure',
                    'highBloodPressureData',
                    false,
                    this.state.extendHealthDeclarationData.hasHighBloodPressure == 'Yes' ? false : true,
                    this.state.highBloodPressureDataEdit,
                    'highBloodPressureDataEdit'
                )}
                {this.renderTableBody(
                    'hasMentalIllness',
                    'mentalIllnessData',
                    false,
                    this.state.extendHealthDeclarationData.hasMentalIllness == 'Yes' ? false : true,
                    this.state.mentalIllnessDataEdit,
                    'mentalIllnessDataEdit'
                )}
                {this.renderTableBody(
                    'hasCancer',
                    'cancerData',
                    false,
                    this.state.extendHealthDeclarationData.hasCancer == 'Yes' ? false : true,
                    this.state.cancerDataEdit,
                    'cancerDataEdit'
                )}
                {this.renderTableBody(
                    'hasHIV',
                    'hivData',
                    false,
                    this.state.extendHealthDeclarationData.hasHIV == 'Yes' ? false : true,
                    this.state.hivDataEdit,
                    'hivDataEdit'
                )}
                {this.renderTableBody(
                    'hasDiabetes',
                    'diabetesData',
                    false,
                    this.state.extendHealthDeclarationData.hasDiabetes == 'Yes' ? false : true,
                    this.state.diabetesDataEdit,
                    'diabetesDataEdit'
                )}
                {this.renderTableBody(
                    'hasObstructivePulmonaryDisease',
                    'pulmonaryData',
                    false,
                    this.state.extendHealthDeclarationData.hasObstructivePulmonaryDisease == 'Yes' ? false : true,
                    this.state.pulmonaryDataEdit,
                    'pulmonaryDataEdit'
                )}
                {this.renderTableBody(
                    'hasLiverDisease',
                    'liverDiseaseData',
                    false,
                    this.state.extendHealthDeclarationData.hasLiverDisease == 'Yes' ? false : true,
                    this.state.liverDiseaseDataEdit,
                    'liverDiseaseDataEdit'
                )}
                {this.renderTableBody(
                    'hasKidneyDisease',
                    'kidneyDiseaseData',
                    false,
                    this.state.extendHealthDeclarationData.hasKidneyDisease == 'Yes' ? false : true,
                    this.state.kidneyDiseaseDataEdit,
                    'kidneyDiseaseDataEdit'
                )}
                {this.renderTableBody(
                    'lossSenses',
                    'lossSensesData',
                    false,
                    this.state.extendHealthDeclarationData.lossSenses == 'Yes' ? false : true,
                    this.state.lossSensesDataEdit,
                    'lossSensesDataEdit'
                )}
                {this.renderTableBody(
                    'physicalDisability',
                    'physicalDisabilityData',
                    false,
                    this.state.extendHealthDeclarationData.physicalDisability == 'Yes' ? false : true,
                    this.state.physicalDisabilityDataEdit,
                    'physicalDisabilityDataEdit',
                )}

            </div>
        )
    }


    isConsultOrTreatment() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isConsultOrTreatment}
                {/* <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            // title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isConsultOrTreatment}
                            value={this.state.extendHealthDeclarationData.isConsultOrTreatment}
                            handleNegativePress={() => this.handleValueChange(this.getFormFields().isConsultOrTreatment, 'No')}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().isConsultOrTreatment, 'Yes')}
                        />
                    </div>
                </div> */}
                {this.renderTableHeader()}
                {this.renderTableBody(
                    'isConsultOrTreatment',
                    'consultationData',
                    true,
                    this.state.extendHealthDeclarationData.isConsultOrTreatment == 'Yes' ? false : true,
                    this.state.consultOrTreatmentEdit,
                    'consultOrTreatmentEdit'
                )}
            </div>
        )
    }

    isInvestigateOrOperation() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isInvestigateOrOperation}
                {this.renderTableHeader()}
                {this.renderTableBody(
                    'prolongedFatigue',
                    'fatigueData',
                    false,
                    this.state.extendHealthDeclarationData.prolongedFatigue == 'Yes' ? false : true,
                    this.state.fatigueDataEdit,
                    'fatigueDataEdit',
                )}
                {this.renderTableBody(
                    'unexplainedWeightLoss',
                    'weightLossData',
                    false,
                    this.state.extendHealthDeclarationData.unexplainedWeightLoss == 'Yes' ? false : true,
                    this.state.weightLossDataEdit,
                    'weightLossDataEdit',
                )}
                {this.renderTableBody(
                    'abnormalLump',
                    'abnormalData',
                    false,
                    this.state.extendHealthDeclarationData.abnormalLump == 'Yes' ? false : true,
                    this.state.abnormalDataEdit,
                    'abnormalDataEdit',
                )}
                {this.renderTableBody(
                    'bloodUrine',
                    'bloodUrineData',
                    false,
                    this.state.extendHealthDeclarationData.bloodUrine == 'Yes' ? false : true,
                    this.state.bloodUrineDataEdit,
                    'bloodUrineDataEdit',
                )}
                {this.renderTableBody(
                    'newPain',
                    'persistentData',
                    false,
                    this.state.extendHealthDeclarationData.newPain == 'Yes' ? false : true,
                    this.state.persistentDataEdit,
                    'persistentDataEdit',
                )}
            </div>
        )
    }

    hasGeneticDisorder() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.extendedHealthFormTitle.hasGeneticDisorder}
                {this.renderTableHeader()}
                {this.renderTableBody(
                    'hasGeneticDisorder',
                    'geneticDisorderData',
                    true,
                    this.state.extendHealthDeclarationData.hasGeneticDisorder == 'Yes' ? false : true,
                    this.state.geneticDisorderDataEdit,
                    'geneticDisorderDataEdit'
                )}
            </div>
        )
    }

    isPregnant() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.isPregnant}
                value={this.state.extendHealthDeclarationData.isPregnant}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isPregnant, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isPregnant, 'Yes')}
            />
        )
    }

    pregnancyMonth() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.pregnancyMonth}
                value={this.state.pregnancyDetails.pregnancyMonth}
                placeholder={'Select number of months...'}
                options={Config.proposal.optionItem.pregnancyMonth}
                onChange={(e) => this.handleDetailsDataValueChange('pregnancyDetails', 'pregnancyMonth', e)}
            />
        )
    }

    medicalCondition() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.medicalCondition}
                type={'text'}
                placeholder={'Write the name of you medical condition...'}
                value={this.state.medicalCondition}
                onChange={this.handleMedicalConditionChange}
            />
        )
    }

    diagnosisDate() {
        return (
            <div className="mt-1">
                {Config.proposal.formDataMapping.step1.extendedHealthFormTitle.dateOfDiagnosis}
                <DatePicker
                    onChange={(d) => this.handleDiagnosisDateChange(d)}
                    style={{ height: '48px', width: '100%', marginTop: '1vh' }}
                    placeholder="DD/MM/YYYY"
                    format={'DD/MM/YYYY'}
                    value={this.state.dateOfDiagnosis}
                />
            </div>
        )
    }

    treatmentPrescribed() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.treatmentPrescribed}
                type={'text'}
                placeholder={'Write the details of your prescribed treatment...'}
                value={this.state.treatmentPrescribed}
                multiline={true}
                showCount={true}
                maxLength={300}
                onChange={this.handleTreatmentPrescribedChange}
            />
        )
    }

    doctorName() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.doctorName}
                type={'text'}
                placeholder={'Write the name of your doctor’s name...'}
                value={this.state.doctorName}
                onChange={this.handleDoctorNameChange}
            />
        )
    }

    doctorAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.doctorAddress}
                type={'text'}
                placeholder={'Enter floor / unit / street name...'}
                value={this.state.doctorAddress}
                onChange={this.handleDoctorAddressChange}
            />
        )
    }

    country() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.country}
                value={this.state.country}
                placeholder={'Select country...'}
                options={this.state.countryList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                showSearch={true}
                onChange={this.handleCountryChange}
            />
        )
    }

    livingState() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.state}
                value={this.state.state}
                placeholder={'Select state...'}
                options={FormBloc.getStateSelections()}
                fieldNames={{ label: ('stateName'), value: ('stateCode') }}
                onChange={this.handleStateChange}
            />
        )
    }

    postcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.postcode}
                value={this.state.postcode}
                placeholder={'Select postcode...'}
                options={
                    this.state.state ?
                        FormBloc.getPostcodeByCode(this.state.state) : FormBloc.getCitySelections()
                }
                fieldNames={{ label: ('postCode'), value: ('postCode') }}
                showSearch={true}
                onChange={this.handlePostcodeChange}
            />
        )
    }

    city() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.extendedHealthFormTitle.city}
                value={this.state.city}
                placeholder={'Select city...'}
                options={
                    this.state.postcode ?
                        FormBloc.getCityByZipCode(this.state.postcode) : FormBloc.getCitySelections()
                }
                fieldNames={{ label: ('cityName'), value: ('cityName') }}
                showSearch={true}
                onChange={this.handleCityChange}
            />
        )
    }

    diagnosedDiseaseData = () => {
        return (
            <div className="w-100">
                <App_table
                    data={this.state.diagnosedDiseaseData || []}
                    collumn={this.columns(this.state.diagnosedDiseaseData, 'diagnosed')}
                />
            </div>
        )
    }

    diseaseDetails = () => {
        return (
            <div className="w-100 mt-4" style={{ height: '50vh', overflowY: 'scroll' }}>
                <div className="mt-3">
                    {this.medicalCondition()}
                </div>
                <div className="mt-3">
                    {this.diagnosisDate()}
                </div>
                <div className="mt-3">
                    {this.treatmentPrescribed()}
                </div>
                <div className="mt-3">
                    {this.doctorName()}
                </div>
                <div className="mt-3">
                    {this.doctorAddress()}
                </div>
                <div className="mt-3">
                    {this.country()}
                </div>
                <div className="mt-3">
                    {this.livingState()}
                </div>
                <div className="mt-3">
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.postcode()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.city()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>

                <div className="w-100 mt-4" >
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.height()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.weight()}
                        </div>
                    </div>
                    <div className="mt-3">
                        {this.isSmoker()}
                    </div>
                    <div className="mt-3">
                        {this.isDiagnosedDisease()}
                    </div>
                    <div className="mt-3">
                        {this.isConsultOrTreatment()}
                    </div>
                    <div className="mt-3">
                        {this.isInvestigateOrOperation()}
                    </div>
                    <div className="mt-3">
                        {this.hasGeneticDisorder()}
                        {/* {
                            this.state.extendHealthDeclarationData.hasGeneticDisorder === 'Yes' &&
                            this.state.geneticDisorderData.length > 0 &&
                            <>
                                <div className="mt-3">
                                    {this.geneticDisorderData()}
                                </div>
                            </>

                        }
                        {
                            this.state.extendHealthDeclarationData.hasGeneticDisorder === 'Yes' &&
                            <div className=" d-flex justify-content-center" style={{ width: this.state.geneticDisorderData.length > 0 ? '100%' : '50%' }}>
                                <Button
                                    className="mt-3"
                                    type="text"
                                    style={{
                                        border: '0px',
                                        color: '#EE7623',
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                    onClick={() => this.handleAddGeneticDisorderDetailModalOpen()}
                                >
                                    <PlusIcon className="mx-2" fill="#EE7623" />
                                    <span className="add_detail_text">Add Details</span>
                                </Button>
                            </div>
                        } */}
                    </div>
                    <div className="mt-3">
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.isPregnant()}
                            </div>
                            {
                                this.state.extendHealthDeclarationData.isPregnant === 'Yes' &&
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.pregnancyMonth()}
                                </div>
                            }

                        </div>
                    </div>
                </div>
                {/* For diagnosed disease detail */}
                <AppModal
                    open={this.state.addDiagnosedDiseaseDetailModalOpen}
                    handleModalClose={() => this.handleAddDiagnosedDiseaseDetailModalOpen()}
                    width={'60%'}
                    title={this.state.isUpdate ? 'Update Details' : 'Add Details'}
                    negativeButtonText={'Cancel'}
                    positiveButtonText={this.state.isUpdate ? 'Update' : 'Add to Table'}
                    handleNegativePress={() => this.handleAddDiagnosedDiseaseDetailModalClose()}
                    handlePositivePress={() => this.state.isUpdate ? this.handleEditDiagnosedDiseaseDetails() : this.handleAddDiagnosedDiseaseDetails()}
                    customButton={true}
                    closable={false}
                >
                    {this.diseaseDetails()}
                </AppModal>
                {/* For consult treatment detail */}
                <AppModal
                    open={this.state.addConsultTreatmentModalOpen}
                    handleModalClose={() => this.handleAddConsultTreatmentDetailslModalOpen()}
                    width={'60%'}
                    title={this.state.isUpdate ? 'Update Details' : 'Add Details'}
                    negativeButtonText={'Cancel'}
                    positiveButtonText={this.state.isUpdate ? 'Update' : 'Add to Table'}
                    handleNegativePress={() => this.handleAddConsultTreatmentDetailslModalClose()}
                    handlePositivePress={() => this.state.isUpdate ? this.handleEditConsultTreatmentDetails() : this.handleAddConsultTreatmentDetails()}
                    customButton={true}
                    closable={false}
                >
                    {this.diseaseDetails()}
                </AppModal>
                {/* For investigation/treatment detail */}
                <AppModal
                    open={this.state.addInvestigationDetailModalOpen}
                    handleModalClose={() => this.handleAddInvestigateOrOperationDetailModalClose()}
                    width={'60%'}
                    title={this.state.isUpdate ? 'Update Details' : 'Add Details'}
                    negativeButtonText={'Cancel'}
                    positiveButtonText={this.state.isUpdate ? 'Update' : 'Add to Table'}
                    handleNegativePress={() => this.handleAddInvestigateOrOperationDetailModalClose()}
                    handlePositivePress={() => this.state.isUpdate ? this.handleEditInvestigateOrTreatmentDetails() : this.handleAddInvestigateOrTreatmentDetails()}
                    customButton={true}
                    closable={false}
                >
                    {this.diseaseDetails()}
                </AppModal>
                {/* For genetic disease detail */}
                <AppModal
                    open={this.state.addGeneticDisorderDetailModalOpen}
                    handleModalClose={() => this.handleAddGeneticDisorderDetailModalClose()}
                    width={'60%'}
                    title={this.state.isUpdate ? 'Update Details' : 'Add Details'}
                    negativeButtonText={'Cancel'}
                    positiveButtonText={this.state.isUpdate ? 'Update' : 'Add to Table'}
                    handleNegativePress={() => this.handleAddGeneticDisorderDetailModalClose()}
                    handlePositivePress={() => this.state.isUpdate ? this.handleEditGeneticDisorderDetails() : this.handleAddGeneticDisorderDetails()}
                    customButton={true}
                    closable={false}
                >
                    {this.diseaseDetails()}
                </AppModal>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ExtendedHealthDeclaration));
